module.exports = __webpack_public_path__ + "img/icone-config-lista.e181deab.svg";